import type React from 'react';

import { useStepManageAccessExternal } from '@/hooks/manageAccess/useStepManageAccessExternal';
import ExternalInvitationStep from '@/components/organism/CreateSix/steps/StepExternal/ExternalInvitationStep';

export interface StepManageAccessExternalProps {
  onClose: () => void;
}

function StepManageAccessExternal(props: StepManageAccessExternalProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepManageAccessExternal();

  return (
    <ExternalInvitationStep
      activeTab={state.activeTabValue}
      onTabChange={handlers.handleTabChange}
      contactsSearchValue={state.contactsSearchValue}
      onContactsSearchValueChange={handlers.handleContactsSearchValueChange}
      contactRows={state.contactRows}
      onAddContact={handlers.handleAddContact}
      selectedParticipants={state.selectedParticipants}
      onRemoveSelectedParticipant={handlers.handleRemoveSelectedParticipant}
      manualRows={state.manualRows}
      onManualRowValuesChange={handlers.handleManualRowValuesChange}
      onAddManualRow={handlers.handleAddManualRow}
      onRemoveManualRow={handlers.handleRemoveManualRow}
      onAddRowToSix={handlers.handleAddRowToSix}
      availableExternalSeats={state.availableExternalSeats}
    />
  );
}

StepManageAccessExternal.displayName = 'StepManageAccessExternal';

export default StepManageAccessExternal;
